import { ProductAvailabilityViewModel } from '../../Catalog/Product/Availability/ProductAvailabilityViewModel.csharp';
import { ProductBuyingMode } from '../../Components/Availability/ProductBuyingMode.csharp';

export class GTMStockLevel {
    public static Get(availability: ProductAvailabilityViewModel) {
        return availability.buyingMode === ProductBuyingMode.Inactive ? 'Out of stock' : 'In stock';
    }
}
